<template>
	<v-card flat max-width="950px" class="mx-auto transparent mb-12 pb-12">

        <div class="headline font-weight-bold primary--text ml-6 mt-6">PERSONAL</div>

        <v-row class="mt-6 mt-sm-12">
            <v-col cols="12" sm="6">
                <div class="d-flex justify-center justify-sm-end mr-sm-6">
                    <v-card flat width="300px" hover color="#DF5B5B" @click="$router.push('/my-profile')">
                        <v-btn fab text absolute x-small class="mt-6 mr-n2" top right>
                            <v-icon size="20" color="primary" style="opacity:.3">fa-info-circle</v-icon>
                        </v-btn>
                        <div class="d-flex align-center">
                            <div class="mx-6">
                                <v-img :src="require('@/assets/homesIcons/profile.png')" width="40"></v-img>
                            </div>
                            <div class="title font-weight-bold primary--text py-6">
                                PROFILE
                            </div>
                        </div>
                    </v-card>
                </div>
            </v-col>

            <v-col cols="12" sm="6">
                 <div class="d-flex justify-center justify-sm-start ml-sm-6">
                    <v-card flat width="300px" hover color="#6E91E6" @click="$router.push('/captains')">
                        <v-btn fab text absolute x-small class="mt-6 mr-n2" top right>
                            <v-icon size="20" color="primary" style="opacity:.3">fa-info-circle</v-icon>
                        </v-btn>
                        <div class="d-flex align-center">
                            <div class="mx-6">
                                <v-img :src="require('@/assets/homesIcons/captains.png')" width="40"></v-img>
                            </div>
                            <div class="title font-weight-bold primary--text py-6">
                                CAPTAINS
                            </div>
                        </div>
                    </v-card>
                 </div>
            </v-col>
        </v-row>

        <v-row class="mt-sm-4">
            <v-col cols="12" sm="6">
                <div class="d-flex justify-center justify-sm-end mr-sm-6">
                    <v-card flat width="300px" hover color="#DED855" @click="$router.push('/awards')">
                        <v-btn fab text absolute x-small class="mt-6 mr-n2" top right>
                            <v-icon size="20" color="primary" style="opacity:.3">fa-info-circle</v-icon>
                        </v-btn>
                        <div class="d-flex align-center">
                            <div class="mx-6">
                                <v-img :src="require('@/assets/homesIcons/awards-badges.png')" width="40"></v-img>
                            </div>
                            <div class="title font-weight-bold primary--text py-6">
                                AWARDS & BADGES
                            </div>
                        </div>
                    </v-card>
                </div>
            </v-col>

            <v-col cols="12" sm="6">
                 <div class="d-flex justify-center justify-sm-start ml-sm-6">
                    <v-card flat width="300px" hover color="#CEFDFD" @click="$router.push('/account')">
                        <v-btn fab text absolute x-small class="mt-6 mr-n2" top right>
                            <v-icon size="20" color="primary" style="opacity:.3">fa-info-circle</v-icon>
                        </v-btn>
                        <div class="d-flex align-center">
                            <div class="mx-6">
                                <v-img :src="require('@/assets/homesIcons/account.png')" width="40"></v-img>
                            </div>
                            <div class="title font-weight-bold primary--text py-6">
                                ACCOUNT
                            </div>
                        </div>
                    </v-card>
                 </div>
            </v-col>
        </v-row>

        <v-row class="mt-sm-4">
            <v-col cols="12">
                <div class="d-flex justify-center">
                    <v-card flat width="300px" hover color="#CEFDC5" @click="$router.push('/how-to')">
                        <v-btn fab text absolute x-small class="mt-6 mr-n2" top right>
                            <v-icon size="20" color="primary" style="opacity:.3">fa-info-circle</v-icon>
                        </v-btn>
                        <div class="d-flex align-center">
                            <div class="mx-6">
                                <v-img :src="require('@/assets/homesIcons/how-to.png')" width="40"></v-img>
                            </div>
                            <div class="title font-weight-bold primary--text py-6">
                                HOW TO
                            </div>
                        </div>
                    </v-card>
                </div>
            </v-col>
        </v-row>

	</v-card>
</template>

<script>
export default {

}
</script>
